import React, { useState } from 'react';
import { Modal } from '../../../components';
import { PrimaryButton, Button } from '../../../components';
import css from './MakeOfferModal.module.css';

const MakeOfferModal = props => {
  const {
    onMakeOffer,
    listing,
    offerModalOpen,
    setOfferModalOpen,
    withControlledState,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [priceValue, setPriceValue] = useState(null);

  const handlePriceChange = e => {
    const value = e.target.value;
    function containsOnlyNumbers(str) {
      return /^\d*$/.test(str);
    }
    if (containsOnlyNumbers(value)) {
      setPriceValue(value);
    }
  };

  const offerButtonLabel = priceValue ? `Send offer for NZ$${priceValue}` : 'Send offer';

  const handleSendOffer = e => {
    e.preventDefault();
    if (priceValue) {
      // Register "AddToCart" event for the Meta Pixel
      console.log("Registering 'AddToCart' Meta Pixel event");
      if( typeof fbq === "function")
        fbq('track', 'AddToCart');

      return onMakeOffer(listing.id, priceValue);
    }
  };

  return (
    <Modal
      isOpen={offerModalOpen}
      className={css.mainWrapper}
      onClose={() => {
        setOfferModalOpen(false);
      }}
      onManageDisableScrolling={() => { }}
    >
      <div className={css.modalContentWrapper}>
        <input
          className={css.offerInput}
          type="text"
          placeholder="$"
          value={priceValue}
          onChange={handlePriceChange}
        />

        <PrimaryButton
          onClick={handleSendOffer}
          className={css.sendOfferButton}
          disabled={!priceValue}
        >
          {offerButtonLabel}
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default MakeOfferModal;
